<template>
  <ul>
    <li v-for="(course, index) in courses" :key="index" @click="onCourseClick(course)">
      <img :src="course.url">
      <div class="desc">
        <h3>{{ course.title }}</h3>
        <p>
          <span class="read">{{ course.read }}</span>
          <span v-if="course.type !== '5'" class="comment">{{ course.comment }}</span>
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'CourseList',
  props: {
    courses: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onCourseClick (course) {
      const { id, type, title } = course
      let data = { id, type, title }
      console.log(course)
      if (course.medias && course.medias[0] && course.medias[0].resUrl) {
        const resType = course.medias[0].resUrl.split('.')
        console.log(resType)
        if (resType[resType.length - 1] === 'mp3') {
          data.type = '1'
        } else {
          data.type = '0'
        }
      }

      switch (data.type + '') {
        case '0': // 课程学习（视频）
        case '1': // 课程学习（音频）
          data.url = '/course/course_detail'
          if (this.$route.query.platform === 'mini') {
            wx.miniProgram.navigateTo({
              url: `/pages/detail/coursedetail/coursedetail?id=${id}&type=${data.type}&name=${title}`
            })
          } else {
            this.$dfzhJsBridge.openCourseDetail(data)
          }
          break
        case '2': // 精选分享
        case '3': // 国学经典
        case '5': // 在线学习
          data.url = '/article/article_detail'
          if (this.$route.query.platform === 'mini') {
            wx.miniProgram.navigateTo({
              url: `/pages/detail/articledetail/articledetail?id=${id}&type=${data.type}&name=${title}`
            })
          } else {
            this.$dfzhJsBridge.openCourseDetail(data)
          }
          break
        case '4': // 课程通知
          data.url = '/notification/notification_detail'
          if (this.$route.query.platform === 'mini') {
            wx.miniProgram.navigateTo({
              url: `/pages/detail/notificationdetail/notificationdetail?id=${id}&type=${data.type}&name=${title}`
            })
          } else {
            this.$dfzhJsBridge.openCourseDetail(data)
          }
          break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
ul
  padding 10px 0 15px 0
  li
    height 80px
    margin-bottom 15px
    position relative
    display flex
    justify-content space-between
    img
      width 144px
      height auto
      display inline-block
    .desc
      flex-grow 1
      text-align left
      padding 4px 0 4px 10px
      position relative
      h3
        color #363636
        font-size 14px
        line-height: 20px
      p
        position absolute
        bottom 0
        left 10px
        color #B8B8B8
        span
          margin-right 20px
          padding-left 22px
        span.read
          background url("~@/assets/images/icons/icon-read.png") no-repeat left center
          background-size 17px 17px
        span.comment
          background url("~@/assets/images/icons/icon-comment.png") no-repeat left center
          background-size 17px 17px
  li:last-child
    margin-bottom 0
</style>
